import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, User, Truck } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import AdminBanner from './AdminBanner';

const TopBar = () => {
  const { getWishlistCount } = useWishlist();
  const count = getWishlistCount();

  return (
    <>
      <AdminBanner />
      <div className="bg-black text-white text-[11px] tracking-[0.2em] uppercase font-medium border-b border-neutral-800">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-between gap-4">
          {/* Left: shipping promo */}
          <div className="hidden sm:flex items-center gap-2">
            <Truck className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span>Envíos gratis desde 80€</span>
          </div>

          {/* Center on mobile */}
          <div className="sm:hidden flex-1 text-center">
            <span>Envíos gratis desde 80€</span>
          </div>

          {/* Right */}
          <div className="flex items-center gap-5">
            <Link
              to="/mi-cuenta"
              className="hidden sm:flex items-center gap-1.5 hover:text-neutral-300 transition-colors"
              data-testid="topbar-account-link"
            >
              <User className="w-3.5 h-3.5" strokeWidth={1.5} />
              <span>Cuenta</span>
            </Link>
            <Link
              to="/wishlist"
              className="relative flex items-center gap-1.5 hover:text-neutral-300 transition-colors"
              data-testid="topbar-wishlist-link"
            >
              <Heart className="w-3.5 h-3.5" strokeWidth={1.5} />
              <span className="hidden sm:inline">Deseos</span>
              {count > 0 && (
                <span
                  className="absolute -top-1.5 -right-2 bg-white text-black text-[9px] tracking-normal font-bold w-4 h-4 rounded-full flex items-center justify-center"
                  data-testid="topbar-wishlist-count"
                >
                  {count}
                </span>
              )}
            </Link>
            <Link
              to="/fidelidad"
              className="hidden md:flex items-center gap-1.5 hover:text-neutral-300 transition-colors"
              data-testid="topbar-loyalty-link"
            >
              <span>Fidelidad</span>
            </Link>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default TopBar;
